function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import Error from '@engine/components/presentational/base/error';
import Icon from '@engine/components/presentational/base/icon';
import Panel from '@engine/components/presentational/base/panel';
import React from 'react';
import Spinner from '@engine/components/presentational/base/spinner';
import { connect } from 'react-redux';
import { fetchLogs } from '@engine/actions/creators/panel-log';

var PanelLog = /*#__PURE__*/function (_React$Component) {
  _inherits(PanelLog, _React$Component);

  var _super = _createSuper(PanelLog);

  function PanelLog(props) {
    var _this;

    _classCallCheck(this, PanelLog);

    _this = _super.call(this, props);
    _this.state = {
      isOpened: false
    };
    return _this;
  }

  _createClass(PanelLog, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Panel.Container, {
        id: this.props.logType
      }, React.createElement(Panel.Header, {
        handleClick: function handleClick() {
          return _this2.toggleOpen();
        }
      }, React.createElement(Icon, {
        icon: this.props.icon
      }), " ", I18n.t("object.names.".concat(this.props.logType)), this.props.isFetching && React.createElement(Spinner, {
        position: "inline",
        color: "refined-blue"
      }), React.createElement("div", {
        className: "pull-right"
      }, React.createElement(Icon, {
        icon: "chevron-down"
      }))), this.props.hasError && this.state.isOpened && React.createElement("div", {
        className: "panel-collapse"
      }, React.createElement(Panel.Body, null, React.createElement(Error, null, I18n.t('javascript.errors.something_went_wrong')))), !this.props.hasError && this.state.isOpened && this.props.isFetched && React.createElement("div", {
        className: "table-responsive panel-collapse"
      }, React.createElement("table", {
        className: "table table-striped table-bordered table-hover"
      }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, I18n.t('object.attributes.id')), React.createElement("th", null, I18n.t('object.attributes.time')), React.createElement("th", null, I18n.t('object.attributes.title')), React.createElement("th", null, I18n.t('object.attributes.message')))), React.createElement("tbody", null, this.props.logs.map(function (log, key) {
        return React.createElement("tr", {
          key: key
        }, React.createElement("td", null, log.id), React.createElement("td", null, log.created_at), React.createElement("td", null, log.title), React.createElement("td", null, React.createElement("pre", null, React.createElement("code", null, _this2.message(log)))));
      })))));
    }
  }, {
    key: "message",
    value: function message(log) {
      if (log.is_link) {
        return React.createElement("a", {
          href: log.message.link
        }, log.message.message);
      }

      return log.message;
    }
  }, {
    key: "fetchLogs",
    value: function fetchLogs() {
      this.props.fetchLogs(this.props.url, this.props.logType);
    }
  }, {
    key: "toggleOpen",
    value: function toggleOpen() {
      if (!this.props.isFetched) {
        this.fetchLogs();
      }

      this.setState({
        isOpened: !this.state.isOpened
      });
    }
  }]);

  return PanelLog;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    hasError: state["panelLog-".concat(ownProps.logType)].hasError,
    isFetched: state["panelLog-".concat(ownProps.logType)].isFetched,
    isFetching: state["panelLog-".concat(ownProps.logType)].isFetching,
    logs: state["panelLog-".concat(ownProps.logType)].logs
  };
};

export default connect(mapStateToProps, {
  fetchLogs: fetchLogs
})(PanelLog);